import styled from '@emotion/styled'

import { spacing, Title, typography } from 'main/ui'

export const Container = styled.div`
  text-align: center;
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const StyledTitle = styled(Title)`
  font-weight: ${typography.fontWeight.regular};
  margin-bottom: ${spacing.majorScale(3)}px;
`
